var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-stat"},[_c('UserDetails_Icon_Small',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"author-stat-text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }